import { ArrowRight, Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Studio() {
  const episodes = [{
    id: 1,
    title: "L'Origine del Progetto",
    duration: "12:45",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_01.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_01.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_01.png-wvc-sizes"
  }, {
    id: 2,
    title: "Sviluppo e Visione",
    duration: "15:20",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_02.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_02.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_02.png-wvc-sizes"
  }, {
    id: 3,
    title: "Il Futuro di Lionia",
    duration: "10:15",
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_03.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_03.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_03.webp-wvc-sizes"
  }];
  return <section id="inside-the-studio" className="py-32 relative overflow-hidden bg-background">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-border">
        <div className="absolute right-0 top-[-2px] size-1 bg-primary" />
      </div>

      <div className="max-w-[1440px] mx-auto px-10 md:px-20">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-end mb-24">
          <div className="md:col-span-8">
            <div className="flex flex-col gap-6">
              <span className="text-sm font-mono uppercase tracking-[0.3em] text-primary">
                Chronos Index — 04
              </span>
              <h2 className="font-sans font-extrabold leading-[1.0] text-foreground text-5xl md:text-7xl lg:text-8xl tracking-tighter">
                INSIDE THE <br />
                <span className="text-primary">lionia project</span>
              </h2>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="space-y-8">
              <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">Esplora tutti  gli argomenti e ospiti del progetto</p>
              <div className="flex flex-wrap gap-4">
                <Button asChild variant="default" size="lg" className="rounded-lg h-14 px-8 group bg-primary hover:bg-primary/90 text-white">
                  <Link to="https://www.youtube.com/@LioniaProject" newTab className="flex items-center gap-2">
                    <span>Vedi tutti gli episodi</span>
                    <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {episodes.map((episode, i) => <div key={episode.id} data-index={i} className="group relative">
              {}
              <div className="absolute -top-2 -left-2 size-8 border-t-2 border-l-2 border-primary opacity-0 group-hover:opacity-100 transition-all duration-500" />
              
              <div className="relative aspect-video overflow-hidden rounded-lg bg-card border border-border">
                <img src={episode.thumbnail} data-wvc-srcset={episode.srcset} data-wvc-sizes={episode.sizes} alt={episode.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                {}
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-500" />
                
                {}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="size-16 rounded-lg bg-primary flex items-center justify-center text-white shadow-xl transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <Play className="size-8 fill-current" />
                  </div>
                </div>

                <div className="absolute bottom-4 right-4 px-2 py-1 bg-black/80 text-white text-xs font-mono rounded-md">
                  {episode.duration}
                </div>
              </div>

              <div className="mt-6 space-y-2">
                <span className="text-xs font-mono text-primary uppercase tracking-widest">Episode 0{episode.id}</span>
                <h3 className="text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                  {episode.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>

      {}
      <div className="absolute bottom-0 right-0 w-1/3 h-px bg-border">
        <div className="absolute left-0 top-[-2px] size-1 bg-primary" />
      </div>
    </section>;
}